var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asyncDataStatus_ready)?_c('div',{staticClass:"col-full"},[_c('h1',[_vm._v(_vm._s(_vm.category.name))]),_vm._v(" "),_c('CategoryListItem',{attrs:{"category":_vm.category}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf65bb40","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageCategory.vue
// module id = H2uP
// module chunks = 1